import { Box, Container, Flex, HStack, Image, Link, Text } from "@chakra-ui/react";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { Link as ReactDOMLink } from "react-router-dom";

function Header() {
  return (
    <Flex as="header" w="full" py="2em">
      <Container maxW="7xl">
        <Flex textTransform="uppercase" alignItems="center" justifyContent="space-between">
          <Link as={ReactDOMLink} to="/" _hover={{ textDecoration: "none" }}>
            <HStack pt={{ base: "1em", md: "0" }} pb={{ base: "0.25em", md: "0" }}>
              <Image
                src="/logo192-transparent.png"
                // src="/logo192-dark.png"
                boxSize="5em"
                alt="BTFDCA Logo"
                mr="0.5em"
                border="1px solid gold"
              />
              <Text fontSize="2xl" fontWeight="bold">
                #BTFDCA
              </Text>
            </HStack>
          </Link>

          <Box fontSize="sm">
            <HStack spacing={8}>
              {/* <Link as={ReactDOMLink} to="/vaults" _hover={{ textDecoration: "none", color: "brand.500" }}>
                Vaults
              </Link> */}

              {/* <Link as={ReactDOMLink} to="" _hover={{ textDecoration: "none", color: "brand.500" }} isExternal>
                Docs
              </Link> */}
            </HStack>
          </Box>

          <Box>
            <ConnectButton label="CONNECT WALLET" accountStatus="address" chainStatus="name" />
          </Box>
        </Flex>
      </Container>
    </Flex>
  );
}

export default Header;
